import { EntraIdRolesList } from '../../components/entraIdRoles/types'

import {
  BaseActionType,
  DELETE_ENTRAID_ROLES_SUCCESS,
  GET_ENTRAID_ROLES_SUCCESS,
  UPSERT_ENTRAID_ROLES_SUCCESS,
} from './actionTypes'

export const getEntraIdRolesSuccess = (
  entraIdRolesList: EntraIdRolesList,
): BaseActionType => ({
  type: GET_ENTRAID_ROLES_SUCCESS,
  payload: entraIdRolesList,
})

export const upsertEntraIdRolesSuccess = (
  entraIdRoles: EntraIdRolesList,
): BaseActionType => ({
  type: UPSERT_ENTRAID_ROLES_SUCCESS,
  payload: entraIdRoles,
})

export const deleteEntraIdRolesSuccess = (
  entraIdRoles: EntraIdRolesList,
): BaseActionType => ({
  type: DELETE_ENTRAID_ROLES_SUCCESS,
  payload: entraIdRoles,
})
